export default __webpack_public_path__ + "static/media/trash-can-icon-png-19.6b5a1538.jpg";